<template>
    <div class="underlineCourse">
        <div class="dataList">
            <div class="dataRow marginB16 white_bg" style="padding: 0;" v-for="(dataItem, index) in dataList"
                 :key="dataItem.id">
                <div class="flexLayout">
                    <div style="width: 140px; margin-right: 8px;">
                        <div class="imageArea roundBorder8 hiddenOverflow w100p"
                             style="height: 83px;">
                            <img class="fullSpace cover" :src="dataItem.coverImg"
                                 v-if="dataItem.coverImg"/>
                        </div>
                    </div>

                    <div class="flexItem">
                        <div class="lineHeight21r14f bold font14r grey20 hiddenOverflow" style="
                                max-height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;"
                             @click="viewItem(dataItem)">
                            {{dataItem.title}}
                        </div>
                        <div class="font12r gold bold marginT12">主办方：{{dataItem.teacherName}}</div>
                    </div>
                </div>
                <div class="marginT12 flexLayout font12r grey" style="line-height: 1.5em;">
                    <div class="flexItem hiddenOverflow showEllipsisIfOverflow" style="height: 1.5em; padding-right: 10px;">
                        <i class="icon locationIcon" style="margin-right: 2px"></i>
                        {{dataItem.city}} | {{dataItem.address}}
                    </div>
                    <div class="flexItem hiddenOverflow showEllipsisIfOverflow" style="height: 1.5em; word-wrap: break-word">
                        <i class="icon clockIcon" style="margin-right: 2px"></i>
                        {{formatDate(dataItem.startTime)}}&nbsp;&nbsp;{{formatTimeRange(dataItem.startTime, dataItem.endTime)}}
                    </div>
                </div>
                <div class="bold grey20 marginT12 clearfix" style="line-height: 30px;">
                    <div class="fl">
                        <strong class="red" v-if="!dataItem.price">免费</strong>
                        <strong class="red font12r" v-if="dataItem.price">￥</strong>
                        <strong class="red" v-if="dataItem.price">{{dataItem.price}}</strong>
                        <span class="marginL4 darkgrey font12r">/限{{dataItem.maxPlayers}}人</span>
                    </div>
                    <div class="fr" style="padding-top: 2px;">
                        <button class="signInCodeButton font14r white marginR16" @click="viewSignInCode(dataItem)">
                            签到码
                        </button>
                        <button class="signUpInfoButton font14r gold" @click="viewSignUpInfo(dataItem)">报名信息</button>
                    </div>
                </div>
            </div>

            <div class="alignCenter paddingV8" v-show="status === 'loading'">
                <i class="icon spinner-loader"></i>
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'ready' && dataList.length < 1">
                暂无任何课程
            </div>

            <div class="paddingV16 alignCenter font14r colorCCC"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                没有更多课程了
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'error'">
                加载数据失败
            </div>

        </div><!-- end .dataList -->

        <courseQrCodeDrawer ref="courseQrCodeDrawer"/>

    </div>

</template>

<script>
// lib and part
import moment from "moment";
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// style
import '../style.scss';

// config
import appConfig from '@/appConfig';

// modules
import courseQrCodeDrawer from './courseQrCodeDrawer';

// util
import appHelper from '@/util/appHelper';

const config = {
    name : 'underlineSponsorCourseList',
    title : '线下课程',
    description : appConfig.name + ' - ' + appConfig.desc,
    apiConfig : {
        list : {
            url : 'portal/underline/v2/course/get/campaigns',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { courseQrCodeDrawer },
    data () {
        return {
            apiConfig: config.apiConfig,
            enableDataList: true,
            autoLoadDataList: appConfig.mode != 'demo'
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.goToPage('underlineCourseDetail', {
                id : dataItem.id
            });
        },
        formatTimeRange(startTime, endTime) {
            return moment(startTime).format('HH:mm') + '-' + moment(endTime).format('HH:mm');
        },
        viewSignInCode(dataItem) {
            this.$refs.courseQrCodeDrawer.qrCodeUrl = dataItem.signinQr;
            this.$refs.courseQrCodeDrawer.open();
        },
        viewSignUpInfo(dataItem) {
            appHelper.goToPage('underlineCourseSponsorSignUpInfo', {
                id : dataItem.id
            });
        }
    }

}
</script>

<style lang="scss" scoped>
.gold {
    color: #C9821A;
}
.signInCodeButton {
    width: 81px;
    height: 30px;
    line-height: 30px;
    background: #FFBC3B;
    border-radius: 15px;
    border: none;
}
.signUpInfoButton {
    width: 89px;
    height: 30px;
    line-height: 30px;
    background: #FFF3DD;
    border-radius: 15px;
    border: none;
}
</style>
